import { ITask, TInvokerStrategySettle } from '../../TInvoker';
import findSuccessful from './findSuccessful';
import aggregateSuccessful from './aggregateSuccessful';
import findError from './findError';
import aggregateError from './aggregateError';
import collectAll from './collectAll';

export default function collectResult(
    tasks: ReadonlyArray<ITask>,
    strategy?: TInvokerStrategySettle,
): any[] | unknown {
    switch (strategy) {
        case TInvokerStrategySettle.successful:
            return findSuccessful(tasks);

        case TInvokerStrategySettle.aggregateSuccessful:
            return aggregateSuccessful(tasks);

        case TInvokerStrategySettle.error:
            return findError(tasks);

        case TInvokerStrategySettle.aggregateError:
            return aggregateError(tasks);

        case TInvokerStrategySettle.all:
            return collectAll(tasks);

        default:
            return aggregateSuccessful(tasks);
    }
}
